export default "__VITE_PUBLIC_ASSET__3568f74d__"